// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "hashed-1/" + (chunkId === 66586 ? "griffel" : chunkId) + "-" + {"13769":"fc5c56571e","66586":"094a590739"}[chunkId] + ".css";
};